export const state = {
  isCtrl : false
}

export const getters = {}

export const mutations = {
  SET_CONTROL (state, value) {
    state.isCtrl = value
  },
}

export const actions = {}
